import React, { memo } from 'react';
import * as S from './style';

interface IProps {
  items?: React.ReactNode;
}

const FltRecCategoryList = ({ items }: IProps) => (
  <S.FltRecCategoryList>{items}</S.FltRecCategoryList>
);

export default memo(FltRecCategoryList);
